import React from 'react';
import { useNavigate } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch } from 'store';
import { MainLayout } from 'components/Layout/MainLayout';
import { prepareContent } from 'components/form/Content/utils';
import {
  saveEventsItem,
  saveEventsItemAsDraft,
} from 'store/slices/events/actions';
import { IEventsItem } from 'store/slices/events/interfaces';
import { StatusesEnum } from 'constants/status';
import { LangEnum } from 'constants/lang';
import { DEFAULT_SEO_STATE } from 'constants/seo';

import { ageRestriction, EventsForm } from './components/EventsForm/EventsForm';

export const Add = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onFinish = (values: IEventsItem) => {
    setIsLoading(true);
    dispatch(saveEventsItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/events');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: IEventsItem) => {
    setIsLoading(true);
    dispatch(saveEventsItemAsDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/events');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/events');
  };

  return (
    <MainLayout pageTitle='Создание'>
      <EventsForm
        onFinish={onFinish}
        onSaveDraft={onSaveDraft}
        cancelButtonHandler={cancelButtonHandler}
        isDraft
        isLoading={isLoading}
        initialValues={{
          ...DEFAULT_SEO_STATE,
          ageRestriction: ageRestriction[0],
          category: null,
          content: prepareContent([]),
          duration: null,
          externalUrl: '',
          gallery: [],
          heroImage: null,
          image: null,
          intro: '',
          lang: LangEnum.ru,
          name: '',
          places: [],
          price: {
            price: null,
            maxPrice: null,
            freePrice: false,
          },
          region: null,
          shortDescription: '',
          status: StatusesEnum.PUBLISHED,
          sortPriority: null,
          sortPriorityMainPage: null,
          tags: [],
        }}
      />
    </MainLayout>
  );
};
